<template>
  <el-container class="healthy page-x" direction="vertical">
    <div class="dialog-list">
      <div
        class="item"
        v-for="(q, i) in qaList"
        :key="i"
        style="margin-bottom: 20px"
        v-show="i < count"
      >
        <p style="margin-bottom: 10px">
          <strong>{{ ++i }}、{{ q.question }}</strong>
        </p>
        <template v-if="q.answer.length > 0">
          <el-tag
            v-for="(a, j) in q.answer"
            :key="j"
            effect="plain"
            style="margin-right: 6px"
          >
            {{ a }}
          </el-tag>
        </template>
      </div>
      <div
        style="
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-size: 30px;
          color: #999;
          text-align: center;
        "
        v-if="showMore"
      >
        <i
          class="el-icon-d-arrow-right"
          style="cursor: pointer; transform: rotate(90deg)"
          @click="showAll()"
        ></i>
      </div>
    </div>
  </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation } from "@/assets/js/options";
export default {
  name: "expertAppointmentDialog",
  components: { dragDialog },
  props: {
    // 标题
    row: {
      type: Object,
      default: "",
    },
  },
  data() {
    return {
      showMore: true,
      qaList: [],
      count: 0,
      title: "",
      cardType, // 证件类型list
      orderState, // 订单状态list
      relation, // 与权益人关系list
      // 弹窗
      dialogVisible: false, // 弹窗visible
      dialogData: {}, // 弹窗中的数据
      historicalTrack: [], // 订单状态历史轨迹
    };
  },
  mounted() {
    this.showDetail();
    console.log(this.row);
  },
  methods: {
    showAll() {
      this.showMore = false;
      this.count = this.qaList.length;
    },
    /**
     * 显示弹窗
     */
    showDetail() {
      this.title = this.row.productName;
      // 清空状态
      this.dialogData = {};
      this.historicalTrack = [];
      // this.dialogVisible = true;
      // 请求
      this.getDetail();
    },

    /**
     * 答题详情
     */
    async getDetail() {
      let _this = this;
      console.log(_this.row.serverId);
      let res = await this.axios.get(this.getApiUrl("qaDetail"), {
        params: { serverId: _this.row.serverId },
      });

      if (res.code === 1) {
        this.qaList = res.data.qaList;
      }
      if (this.qaList.length > 10) {
        this.showMore = true;
        this.count = 10;
      } else {
        this.showMore = false;
        this.count = this.qaList.length;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
  .title {
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
    font-weight: bold;
    padding-left: 20px;
    margin-top: 18px;
    position: relative;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 8px;
      background-color: $theme;
    }
  }

  .dialog-list-box {
    padding-bottom: 10px;
    display: flex;

    .dialog-list-title {
      padding-left: 20px;
      width: 100px;
      white-space: nowrap;
      text-align: right;
    }

    .dialog-list-text {
      flex: 1;
    }
  }
}
</style>
